{
    "ai_modal_title_1": "crwdns10472241:0crwdne10472241:0",
    "ai_modal_title_2": "crwdns10472243:0crwdne10472243:0",
    "ai_description": "crwdns10472245:0crwdne10472245:0",
    "ai_learn_more": "crwdns10472247:0crwdne10472247:0",
    "ai_copy_text": "crwdns10472249:0crwdne10472249:0",
    "ai_describe_your_text": "crwdns10472251:0crwdne10472251:0",
    "ai_describe_your_text_example": "crwdns10472253:0crwdne10472253:0",
    "ai_new_request": "crwdns10472255:0crwdne10472255:0",
    "ai_create_text": "crwdns10472257:0crwdne10472257:0",
    "ai_apply_text": "crwdns10472259:0crwdne10472259:0",
    "ai_try_one_more": "crwdns10472261:0crwdne10472261:0",
    "ai_correct_errors": "crwdns10472263:0crwdne10472263:0",
    "ai_make_longer": "crwdns10472265:0crwdne10472265:0",
    "ai_make_shorter": "crwdns10472267:0crwdne10472267:0",
    "ai_simplify": "crwdns10472269:0crwdne10472269:0",
    "ai_business_tone": "crwdns10472271:0crwdne10472271:0",
    "ai_ceremonial_tone": "crwdns10472273:0crwdne10472273:0",
    "ai_fun_tone": "crwdns10472275:0crwdne10472275:0",
    "ai_friendly_tone": "crwdns10472277:0crwdne10472277:0",
    "ai_change_tone": "crwdns10472279:0crwdne10472279:0",
    "ai_improve_text": "crwdns10472281:0crwdne10472281:0",
    "ai_words_number": "crwdns10472283:0crwdne10472283:0",
    "ai_translate": "crwdns10472285:0crwdne10472285:0",
    "ai_translate_to_ru": "crwdns10472287:0crwdne10472287:0",
    "ai_translate_to_en": "crwdns10472289:0crwdne10472289:0",
    "ai_add_creativity": "crwdns10472291:0crwdne10472291:0",
    "ai_text_too_large": "crwdns10472293:0crwdne10472293:0",
    "ai_translate_to_ua": "crwdns10472295:0crwdne10472295:0",
    "ai_translate_to_es": "crwdns10472297:0crwdne10472297:0",
    "ai_translate_to_pt": "crwdns10472299:0crwdne10472299:0",
    "ai_translate_to_tr": "crwdns10472301:0crwdne10472301:0",
    "ai_translate_to_fr": "crwdns10472303:0crwdne10472303:0",
    "ai_translate_to_de": "crwdns10472305:0crwdne10472305:0",
    "ai_translate_to_it": "crwdns10472307:0crwdne10472307:0",
    "ai_translate_to_pl": "crwdns10472309:0crwdne10472309:0",
    "ai_free_request_error": "crwdns10472311:0crwdne10472311:0",
    "ai_free_request_number": "crwdns10472313:0{{ FREE_KEY }}crwdnd10472313:0{{ FREE_KEY_LIMIT }}crwdne10472313:0",
    "ai_request_limit_info": "crwdns10472315:0crwdne10472315:0",
    "cancel": "crwdns10472317:0crwdne10472317:0",
    "gpt_error_quota": "crwdns10472319:0crwdne10472319:0"
}
